module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00048-fs8.9e1a0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00048-fs8.png
// module id = 201
// module chunks = 0